import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M9.1 22L2 19.8v-16l6.9 2.2 7-4L22 4.3v16.2L16 18l-6.9 4zM4 6.5v11.9l4 1.3V7.7L4 6.4zm10-1.1l-4 2.3v11.7l4-2.3V5.3zM16 4V16l4 1.6V5.7L16 4z" }));
export {
  l as ReactComponent
};
